import React from 'react';
import { HeroSection } from '@/components/home/HeroSection';
import { ServicesOverview } from '@/components/home/ServicesOverview';
import { WhyChooseEDX } from '@/components/home/WhyChooseEDX';
import { FeaturedGallery } from '@/components/home/FeaturedGallery';
import { FinalCTA } from '@/components/home/FinalCTA';

export const Home = ({ onOpenLeadModal }) => {
  return (
    <div data-testid="home-page">
      <HeroSection onOpenLeadModal={onOpenLeadModal} />
      <ServicesOverview />
      <WhyChooseEDX />
      <FeaturedGallery />
      <FinalCTA onOpenLeadModal={onOpenLeadModal} />
    </div>
  );
};